import { useEffect, useState } from "react";
import { useMessage } from "../../global-components/src";
import { getLinkStore, getPlatform, getStore, isWebView } from "../../utils/platform";

export default function NotificationDownloadApp(){
    const { setMessage } = useMessage();
    const [viewMessage, setViewMessage] = useState(!!sessionStorage.getItem("viewDownloadMessage"));
    const store = getStore();
    const linkStore = getLinkStore();

    if(isWebView() || viewMessage || !store || !linkStore) return; 

    useEffect(() => {
        const message = `O Paçoca está disponível para ${getPlatform()} \n${linkStore}`;
        setMessage(message, "success", `Baixe o Paçoca ${store && store != "Paçoca Store" ? `na ${store}` : ""}`);
        sessionStorage.setItem("viewDownloadMessage", String(true));
    }, []);

    return null;
}